import barba from "@barba/core";
import {TweenMax, Linear, Power3} from "gsap";
import modular, { module } from 'modujs';



export default class extends module {
    constructor(m) {
        super(m);
        this.overlay = document.querySelector( '[data-menu-overlay]' );
        this.html = document.getElementsByTagName('html')[0];
    }
    init() {
        let that = this;
        that.prevHeaderClass = '';
        barba.init({
            /*debug: true,*/
            timeout: 10000,
            transitions: [{
                name: 'opacity-transition',
                leave: (data) => {
                    that.prevHeaderClass = data.current.container.dataset.headerClass;
                    this.html.classList.add( 'is-loading' );
                },
                beforeEnter : (data) => {
                    this.html.classList.remove( 'is-loading' );
                    that.call( 'navigateOut', [that.prevHeaderClass, data.next.container.dataset.headerClass], 'PageHeader' );
                },
                enter: data => {


                    let adminBar = document.getElementById( 'wpadminbar' );
                    if( adminBar ){
                        var temp = new DOMParser().parseFromString(data.next.html, "text/html").documentElement;
                        document.getElementById( 'wpadminbar' ).innerHTML = temp.querySelector('#wpadminbar').innerHTML;
                    }






                    return new Promise(resolve => {
                        TweenMax.fromTo( data.next.container, { opacity : 0 },
                            { opacity : 1,  duration: 0.5, delay: 0.2, ease: Power3.easeInOut, onComplete : () => {
                                    resolve();
                                }});
                    });
                },
                after(data) {

                    const nextEl = data.next.container;
                    if (nextEl) {

                        let forms =  document.querySelectorAll( '.wpcf7-form' );
                        if( forms.length && wpcf7){
                            [...forms].forEach( form => wpcf7.init( form ) )
                        }

                        const nextScripts = nextEl.querySelectorAll('script');
                        nextScripts.forEach(nextScript => {
                            if(nextScript.type !== 'application/ld+json'){
                                eval( nextScript.innerHTML );
                            }
                        });

                    }

                    that.call( 'destroy', data.current.container, 'app' );
                    that.call( 'update', data.next.container, 'app' );
                    //that.call('hide', false, 'Burger');
                }
            }],

            prevent: ({el}) => {
                return /.pdf/.test(el.href.toLowerCase()) || el.classList && el.classList.contains('ab-item');
            }
        });
    }
    destroy(){

    }
}



